import Decimal from 'decimal.js';

const formatNumber = (value) => {
	if (value) {
		return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
	}
	return '0';
};

const formatCurrency = (value, currency = '$') => {
	if (value === null || value === undefined || value === '') {
		return currency + (currency === '៛' ? ' ' : '') + '0.00';
	}

	const num = Number(value);
	if (Number.isNaN(num)) return value;

	const rounded = Math.round(num * 100) / 100;

	return currency + (currency === '៛' ? ' ' : '') + rounded.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const formatPercentage = (value) => {
	if (value) {
		return value.toString() + '%';
	}
	return null;
};

// KHR | km-KH;
// USD| en-US;

const toFormatCurrency = (input, currency = 'USD', decimalPlaces = 2, locale = 'en-US', rounding = Decimal.ROUND_HALF_UP) => {
	const rounded = new Decimal(+input || 0).toDecimalPlaces(decimalPlaces, rounding);
	const options = currency
		? {
				minimumFractionDigits: currency === 'KHR' ? 0 : decimalPlaces,
				maximumFractionDigits: currency === 'KHR' ? 0 : decimalPlaces,
				style: 'currency',
				currency,
			}
		: { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces };
	return new Intl.NumberFormat(locale, options).format(rounded.toNumber());
};

const toNumberFromCurrency = (currency) => {
	if (!currency) return 0;
	return new Decimal(currency.replace(/[^0-9.-]/g, '')).toNumber();
};

const toNumberFromPercent = (percent) => {
	if (!percent || percent === '%') return 0;
	return new Decimal(percent.replace(/[^0-9.-]/g, '')).div(100).toNumber();
};

export { formatNumber, formatCurrency, formatPercentage, toFormatCurrency, toNumberFromCurrency, toNumberFromPercent };
